import React, { useContext } from "react"
import { IoIosArrowDown } from "react-icons/io"
import AppContext from "../../shared/AppContext"
import PageButton from "./PageButton"
import WhitePaperButton from "./WhitePaperButton"
import "./modelPageNavigation.scss"

const getModelType = (path) => {
  const pathArr = path.split("/")

  if (pathArr && pathArr.length && pathArr[2]) {
    return pathArr[2].toLowerCase() === "overview"
      ? "Survey Highlights"
      : pathArr[2]
  }
}

const ModelPageNavigation = (props) => {
  const {
    menuName = "",
    path = "",
    items = [],
    isReportSelected,
    selectedPage,
    setOnClickChapter,
    showMenu,
    selectedItem,
  } = props

  const { trackEvent } = useContext(AppContext)

  const hoverMenu = () => {
    setOnClickChapter(menuName)
  }

  const unHoverMenu = () => {
    setOnClickChapter("")
  }

  const subMenu = items && items.length

  const selectedButtonClass = "selected-button model-page-navigation-button"

  const dataCyName = menuName.replace(/ /g, "-").toLowerCase()

  return (
    <div className="model-page-navigation-container">
      {!subMenu ? (
        <span
          onClick={() =>
            trackEvent("Model Menu Interaction", {
              "Menu Level": "Top Level Menu",
              "Menu Model": getModelType(path),
              "Menu Dropdown": menuName,
              "Menu Label": menuName,
            })
          }
        >
          <a
            href={path}
            data-cy={`model-page-navigation-button`}
            className={
              isReportSelected
                ? selectedButtonClass
                : "model-page-navigation-button"
            }
          >
            <span>{menuName}</span>
          </a>
        </span>
      ) : (
        <>
          <div
            data-cy={`model-page-navigation-button`}
            className={
              isReportSelected
                ? selectedButtonClass
                : "model-page-navigation-button"
            }
            onMouseEnter={hoverMenu}
            onMouseLeave={unHoverMenu}
          >
            <span>{menuName}</span>
            <IoIosArrowDown className="icon" />
          </div>
          <div
            className={"model-page-navigation-submenu"}
            data-cy={`${dataCyName}-model-page-navigation-submenu`}
            onMouseEnter={hoverMenu}
            onMouseLeave={unHoverMenu}
          >
            {showMenu ? (
              <>
                {items.map((item, idx) => {
                  let itemSelected
                  if (selectedItem) {
                    itemSelected = selectedItem === item.itemName
                  }
                  if (!selectedItem && item.pageName) {
                    itemSelected =
                      isReportSelected && selectedPage === item.pageName
                  }
                  if (item.pageName || item.itemName) {
                    return (
                      <PageButton
                        key={idx}
                        id={idx}
                        displayName={item.displayName}
                        path={item.path}
                        tooltip={item.tooltip}
                        selected={itemSelected}
                        onClick={() =>
                          trackEvent("Model Menu Interaction", {
                            "Menu Level": "Nested Menu",
                            "Menu Label": item.displayName,
                            "Menu Model": getModelType(path),
                            "Menu Dropdown": menuName,
                          })
                        }
                      />
                    )
                  } else {
                    return (
                      <WhitePaperButton
                        key={idx}
                        displayName={item.displayName}
                        path={item.path}
                        onClick={() =>
                          trackEvent("Download Content", {
                            "Menu Label": item.displayName,
                            "Menu Model": getModelType(path),
                            "Menu Dropdown": menuName,
                            "Content Type": "White Paper",
                          })
                        }
                      />
                    )
                  }
                })}
              </>
            ) : null}
          </div>
        </>
      )}
    </div>
  )
}

export default ModelPageNavigation
